/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Column_TrackInputs */



/**
* | output |
* | --- |
* | "Track" |
*
* @param {Editor_Table_Column_TrackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_column_track = /** @type {((inputs?: Editor_Table_Column_TrackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Column_TrackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Piste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schiene")
	if (locale === "it") return /** @type {LocalizedString} */ ("Traccia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отслеживать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("追踪")
	if (locale === "ja") return /** @type {LocalizedString} */ ("追跡")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रास्ता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Acompanhar")
	return /** @type {LocalizedString} */ ("Track")
});